import { commonKeywords } from "./common";

const en = {
    seo: {
        title: "xsiadron - Lukasz Frydrych (Luke Frydrych) | Game, App & Web Developer",
        description:
            "xsiadron.com is the portfolio of Lukasz Frydrych, also known as Luke Frydrych and xsiadron, featuring indie game, app, web, tool, and creative software projects.",
        siteName: "xsiadron.com",
        locale: "en_US",
        language: "en",
        keywords: [
            ...commonKeywords,
            "indie game developer",
            "app developer",
            "web developer",
            "React developer",
            "Next.js developer",
            "Poland developer",
        ],
    },
    nav: {
        about: "About",
        projects: "Projects",
        socials: "Socials",
        home: "Home Page",
        privacy: "Privacy Policy",
        languageLabel: "Language",
    },
    about: {
        fullname: "Luke Frydrych",
        rolePrefix: "Indie",
        roleGame: "game",
        roleApp: "app",
        roleWeb: "web",
        roleSuffix: "developer",
        greeting: "Hey!",
        intro: "I'm a creative programmer from Poland, turning ideas into digital work",
        introSecond: "Passionate about crafting precise and high-quality projects.",
        builtPrefix: "My projects are built in",
        tools: {
            game: "Unreal Engine",
            android: "Android Studio",
            graphics2d: "2D Graphics Software",
            graphics3d: "3D Graphics Software",
            media: "Audio && Video Editing Software",
            various: "&& various",
            ides: "IDEs",
        },
        languagesPrefix: "I develop in",
        contact: "Interested in working together?",
        contactLink: "Feel free to reach out!",
    },
    skills: {
        heading: "Skills",
        items: {
            "Game Development": {
                name: "Game Development",
                description:
                    "Creating interactive games and experiences using various game engines and frameworks",
            },
            "Web Development": {
                name: "Web Development",
                description:
                    "Full-stack web development using modern technologies like React, Next.js, and Node.js",
            },
            "App Development": {
                name: "App Development",
                description: "Building mobile and desktop applications with intuitive user interfaces",
            },
            Scripting: {
                name: "Scripting",
                description: "Automation, data processing and tool development using various scripting languages",
            },
            "3D Modeling": {
                name: "3D Modeling",
                description: "Creating 3D models, animations and interactive 3D experiences",
            },
            Illustration: {
                name: "Illustration",
                description: "Digital art, UI/UX design and visual content creation",
            },
        },
    },
    projects: {
        heading: "Projects",
        noResults: "No projects match the selected filters.",
        moreDetails: "More details",
        openProject: "Open {{title}}",
        moreAbout: "More details about {{title}}",
        filter: {
            searchProjects: "Search projects...",
            searchTags: "Search tags...",
            switchToTag: "Switch to tag search",
            switchToProject: "Switch to project search",
            tags: "Tags",
            projects: "Projects",
            clearAll: "Clear all",
            clearAllTitle: "Clear all filters",
            removeTag: "Click to remove",
        },
        categories: {
            "Project Types": "Project Types",
            "Programming Languages": "Programming Languages",
            "Tools & Platforms": "Tools & Platforms",
        },
        tags: {
            Game: "Game",
            Web: "Web",
            App: "App",
            Script: "Script",
            "3D": "3D",
            "2D": "2D",
            Videos: "Videos",
            Android: "Android",
            Software: "Software",
            Editor: "Editor",
            Mobile: "Mobile",
            Polish: "Polish",
            Productivity: "Productivity",
            "Chrome Extension": "Chrome Extension",
        },
        items: {
            "librus-statistics": {
                date: "June 2023",
                description:
                    '<b>Librus Statistics</b> is a web application developed using React. App is dedicated to polish residents that allows you to access information from: <a style="color: #608fbf; font-weight: bold;" href="https://portal.librus.pl/rodzina" target="_blank" rel="noopener noreferrer">portal.librus.pl/rodzina</a>.<br/><br/>Includes information about your own account in terms of subjects, attendance, and grades of the current year.',
            },
            litecode: {
                date: "January 2026",
                description:
                    '<b>LiteCode</b> is a modern, grid-based workspace for creating <span style="background:linear-gradient(90deg,#0aa1ff,#8f69ff,#ff4aa9); -webkit-background-clip:text; background-clip:text; color:transparent; opacity: 0.5; filter: invert(1) hue-rotate(180deg); blur(12px) saturate(120%); mix-blend-mode: difference;">expressive</span> and <span>designed</span> code snippets.<br><br><span style="color:#94a3b8">-</span> Pan and zoom on grid<br><span style="color:#94a3b8">-</span> Theme and layout freely!<br><span style="color:#94a3b8">-</span> Resize, align, and fine-tune every detail<br><span style="color:#94a3b8">-</span> Customize background, padding, and roundness<br><span style="color:#94a3b8">-</span> Copy, export, and save instantly<br><br><span style="background:linear-gradient(90deg,#facc15,#f97316); -webkit-background-clip:text; background-clip:text; color:transparent;">Built for developers.</span> <span style="color:#64748b">Designed for everyone.</span>',
            },
            veamly: {
                date: "February 2023",
                description:
                    '<b>Veamly</b> is native android application allowing to save your own meanings of words or their translations.<br /><br /><span style="color: #608fbf; font-weight: bold;">App facilitates memorization and learning</span> & can be used as well as a kind of <b>notebook</b>.<br /><br />Once installed, you will find many different functionalities including:<ul><li><b>Self-created dictionaries</b></li><li><b>Advanced memorisation tests</b></li><li><b>Flash cards to teach new vocabulary</b></li></ul>Enjoy learning with <b>Veamly</b>.',
            },
            "youtube-music-manager": {
                date: "July 2024",
                description:
                    "<strong>YouTube Music Manager</strong> is a must-have extension!<br />Add precise volume <b>percentages</b> to the slider and enjoy improved <b>responsiveness</b>.<br /><br /><strong>Build-in Auto-Pause Manager</strong> pauses music when you play videos and <i>resumes it automatically</i> when they stop, making <b>multitasking</b> seamless and convenient.",
            },
        },
    },
    socials: {
        heading: "Socials",
        support: "Support me :D",
        patreon: "Patreon",
    },
    footer: {
        privacy: "Privacy Policy",
        copyright: "Copyright © {{year}}. Created by Luke `xsiadron` Frydrych",
    },
    cookies: {
        message:
            "This site uses cookies to remember your language and improve your experience.",
        privacyLink: "Learn more",
        accept: "Got it",
        decline: "Decline",
    },
    privacy: {
        title: "Privacy Policy",
        seoTitle: "Privacy Policy | xsiadron.com",
        seoDescription: "Privacy policy for digital content, games, apps, and websites created by xsiadron.",
        sections: [
            {
                heading: "I. General provisions",
                paragraphs: [
                    "This privacy policy outlines how the personal data of Users, necessary for providing services related to all games, applications, websites, and other digital content created by xsiadron (Lukasz Frydrych), are collected, processed, and stored.",
                    "The service collects only personal data necessary for the provision and development of the services offered.",
                    "Personal data collected through the service is processed in accordance with the Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the protection of natural persons with regard to the processing of personal data.",
                ],
            },
            {
                heading: "II. Data controller",
                paragraphs: [
                    "The data controller for personal data is xsiadron, and for mobile apps available on Google Play, also Google Play.",
                ],
            },
            {
                heading: "III. Purpose of collecting personal data",
                list: [
                    "Communication with the User (contact form, etc.).",
                    "Newsletter delivery (after the User's consent to receive it).",
                    "Provision of social services.",
                    "Promotion of the Administrator's offer.",
                    "Marketing, remarketing, affiliation.",
                    "Personalization of the Service for Users.",
                    "Ensure optimal application performance and record user actions.",
                    "Analytical and statistical activities.",
                ],
                paragraphs: [
                    "Providing data is voluntary but necessary to conclude a contract and use functionalities of the Service.",
                ],
            },
            {
                heading: "IV. Sharing personal data",
                paragraphs: [
                    "User personal data may be transferred depending on the functionality to entities associated with the Administrator, its subcontractors, entities cooperating with the Administrator, e.g., companies handling e-payments, courier/postal service companies, law firms.",
                ],
            },
            {
                heading: "V. User rights",
                list: [
                    "Access their personal data.",
                    "Rectify, delete, or restrict processing of their data.",
                    "Transfer their data.",
                    "Object to processing.",
                    "Withdraw consent at any time (which does not affect the lawfulness of processing based on consent before its withdrawal).",
                ],
                contact: "Users can submit a request regarding their rights to",
            },
            {
                heading: "VI. Cookies and analytics tools",
                paragraphs: [
                    "The Service uses cookies necessary for its correct operation, e.g. to remember your selected language.",
                    "With the User's consent, given via the cookie banner displayed on first visit, the Service also uses the following analytics tools: Google Analytics (provided by Google LLC) to collect anonymized statistics about site traffic, and Microsoft Clarity (provided by Microsoft Corporation) to analyze anonymized user behavior (e.g. clicks, scrolling, session recordings) in order to improve the Service.",
                    "These analytics tools are only loaded in the User's browser after consent is given and are not active if the User declines or has not yet responded to the cookie banner.",
                    "Consent can be withdrawn at any time by clearing the browser's site data (cookies and local storage) for this domain, which will cause the cookie banner to be shown again on the next visit.",
                    "Data processed by Google Analytics and Microsoft Clarity is subject to the respective privacy policies of Google LLC and Microsoft Corporation.",
                ],
            },
            {
                heading: "VII. Contact details",
                contact: "For any inquiries, please contact via email:",
            },
            {
                heading: "VIII. Final provisions",
                paragraphs: [
                    "The Administrator has the right to make changes to the Privacy Policy, with Users' rights not being limited.",
                ],
            },
        ],
    },
};

export default en;
